<template>
  <div class="content-wrap">
    <NaviBox02/>
    <div class="tit-group02">
      <h2 class="tit">{{t('message.actionManagementDetailSettings')}}</h2>
    </div>
    <div class="content-box">
      <div class="form-group col-ty">
        <div class="form-row">
          <div class="txt-tit">{{t('message.code')}}<span class="imp">*</span></div>
          <div class="row">
            <div class="txt">{{behaviorCode}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.behaviorName')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input :placeholder="t('message.enterActionName')" v-model="behaviorTitle" :name="'behaviorTitle'" class="size04"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.category')}}<span class="imp">*</span></div>
          <div class="row">
            <Select v-bind="sortTypeSelect" v-model="sortType" :name="'sortType'" />
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.categoryType')}}<span class="imp">*</span></div>
          <div class="row">
            <Select v-bind="categoryIdxSelect" v-model="categoryIdx" :name="'categoryIdx'"/>
            <div class="col-dv">
              <c-btn01 :btnText="t('message.addOrEdit')" :btnType="'button'" @click="onClickCategoryDialog"/>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row" v-if="false">
          <div class="txt-tit">{{t('message.observationItem')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input :placeholder="t('message.enterObservationItem')" class="size04" v-model="behaviorContent" :name="'behaviorContent'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.type')}}
            <c-tooltip :TooltipText="t('message.sortByScoreAsc')"/>
          </div>
          <div class="row">
            <div class="radio-group">
              <v-radio-group v-model="behaviorTypeModel">
                <v-radio color="indigo" :label="t('message.countType')" value="1"></v-radio>
                <v-radio color="indigo" :label="t('message.singleChoiceType2')" value="2"></v-radio>
                <v-radio color="indigo" :label="t('message.likertBarsType')" value="3"></v-radio>
                <!-- <v-radio color="indigo" :label="t('message.barsType')" value="4"></v-radio> -->
                <v-radio color="indigo" :label="t('message.multipleChoiceType')" value="5"></v-radio>
                <v-radio color="indigo" :label="t('message.otherType')" value="6"></v-radio>
              </v-radio-group>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row" v-if="behaviorTypeModel != '1' && behaviorTypeModel != '2' && behaviorTypeModel != '6'">
          <div class="txt-tit ty01">
            {{t('message.itemsPerPage')}}
          </div>
          <div class="row">
            <Select v-bind="commentCntSelect" v-model="commentCnt" />
            <div class="col-dv" v-if="false">
              <div class="check-group">
                <v-checkbox v-model="multiYn" :label="t('message.multipleSelection')" true-value="Y" false-value="N"></v-checkbox>
              </div>
            </div>
            <div class="row-dv" v-if="behaviorTypeModel != '2'" v-for="(item, i) in behaviorComments" :key="i">
              <c-Input :placeholder="t('message.enterTitle')" class="size05" v-model="item.commentTitle" :name="`behaviorComments[${i}].commentTitle`"/>
              <c-Input :placeholder="t('message.enterText')" class="size01" v-if="behaviorTypeModel != '5'" v-model="item.commentContent" :name="`behaviorComments[${i}].commentContent`"/>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.tag')}}</div>
          <div class="row">
            <c-Input :placeholder="'#tag1, #tag2'" class="size04" v-model="tag" :name="'tag'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.isRequired')}}
          </div>
          <div class="row">
            <v-switch v-model="essentialYn" :name="'essentialYn'" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.changeInfo')}}
          </div>
          <div class="row">
            <c-btnText01 :btnText="historyCnt" @click="showDialog"/>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 :btnText="t('message.list')" @click.stop="onClickGoList()"/>
      </div>
      <div class="wr">
        <c-btn02 :btnText="t('message.delete')" @click="dialogPageDelModel=true"/>
        <c-btn01 :btnText="t('message.registerOrUpdate')" @click="handleForm"/>
      </div>
    </div>
  </div>
  <DialogCategory
    v-model="categoryDialogModel"
    :popTitle="t('message.categoryType')"
    @close="closePopupCB"/>
  <!--삭제-->
  <c-dialog v-model="dialogPageDelModel"
            v-bind="dialogPageDelBind"
            @close="dialogPageDelModel=false"/>
  <!--변경정보-->
  <c-dialog v-model="dialogChangeNumModel"
            v-bind="dialogChangeNumBind"
            :dialogText="historyDialogText"
            @close="dialogChangeNumModel=false"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {Form, useForm} from "vee-validate";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import {useRoute} from "vue-router";
import { useI18n } from 'vue-i18n';
import LogService from "@/services/log.service";
import dayjs from "dayjs";
const { t } = useI18n();

//store
const route = useRoute()
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
  behaviorTitle: yup.string().required(() => t('message.requiredField')),
  /*
  behaviorContent: yup.string().required(() => t('message.requiredField')),
  behaviorComments: yup.array().of(
    yup.object().shape({
      commentTitle: yup.string().required(() => t('message.requiredField')),
      commentContent: yup.string().required(() => t('message.requiredField')),
    })
  )
  */
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const viewIdx = route.params.idx!='null'?route.params.idx:''
const categoryDialogModel = ref(false)
const dialogPageDelModel = ref(false)
const behaviorTitle = ref('')
const sortType = ref('1')
const categoryIdx = ref('')
const behaviorContent = ref('')
const commentCnt = ref(1)
const multiYn = ref('Y')
const tag = ref('')
const essentialYn = ref('N')
const behaviorCode = ref('')
const behaviorComments = ref([{commentTitle:'', commentContent:''}])
const behaviorTypeModel = ref('1')
const dialogChangeNumModel = ref(false)
const historyCnt = ref(0)
const historyDialogText = ref('')

//ui
const sortTypeSelect = ref({items: [{name: t('message.behavior'), value: '1'}, {name: t('message.status'), value: '2'}]})
const categoryIdxSelect = ref({items: [{name: t('message.select'), value: ''}]})
const commentCntSelect = ref({items: [{name: '1', value: 1}, {name: '2', value: 2}, {name: '3', value: 3}, {name: '4', value: 4}, {name: '5', value: 5}]})
let dialogChangeNumBind = {
  dialogTit: t('message.changeInfoFormat'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}
const dialogPageDelBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//hook
onMounted(() => {
  if (!utils.isEmpty(viewIdx)) {
    let params = {
      idx: viewIdx
    }

    BbsService.getBehavior(params).then(
      (response) => {
        behaviorCode.value = response.result.idx
        behaviorTitle.value = response.result.behaviorTitle
        sortType.value = response.result.sortType
        categoryIdx.value = response.result.categoryIdx
        behaviorContent.value = response.result.behaviorContent
        tag.value = response.result.tag
        essentialYn.value = response.result.essentialYn
        behaviorTypeModel.value = response.result.behaviorType
        behaviorComments.value = response.result.behaviorCommentArr
        historyCnt.value = response.result.historyCnt?response.result.historyCnt:0
        const commentLength = behaviorComments.value.length
        //watch에서 처리
        commentCnt.value = commentLength
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
  getCategoryList()
})

//watch
watch(commentCnt, (newValue) => {
  let newCnt = newValue
  let oldCnt = behaviorComments.value.length
  if(newCnt > oldCnt){
    for (let i = 1; i <= newCnt; i++) {
      if (i > oldCnt) {
        let tempObj = { commentTitle:'', commentContent:'' }
        behaviorComments.value.push(tempObj)
      }
    }
  }
  else if(newCnt < oldCnt){
    behaviorComments.value = behaviorComments.value.slice(0, newCnt)
  }
})

//function
const handleForm = async ()=>{
  if(import.meta.env.MODE == 'development') {
    onClickGoList()
  }
  else{
    const result = await validate(); // 전체 필드 검증 실행
    if(!result.valid)
      return

    let companyIdx = localStorage.getItem('companyIdx')

    let params = {
      idx:viewIdx,
      companyIdx: companyIdx,
      behaviorTitle: behaviorTitle.value,
      sortType: sortType.value,
      categoryIdx: categoryIdx.value,
      behaviorContent: behaviorContent.value,
      commentCnt: commentCnt.value,
      behaviorComments:behaviorComments.value,
      tag: tag.value,
      essentialYn: essentialYn.value,
      actionType:'2',
      behaviorType: behaviorTypeModel.value  //1:카운트 2:선택형 3:리커드 4:바 5:다중선택 6:기타
    }

    BbsService.insertBehavior(params).then(
      (response) => {
        if(response.success)
          utils.movePage('/safetyLeadershipAMList')
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
const onClickGoList = ()=>{
  utils.movePage('/safetyLeadershipAMList')
}

const closePopupCB = (type)=>{
  categoryDialogModel.value=false
  if(type === 'refresh')
    getCategoryList()
}

const  getCategoryList = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
    actionType:'2'
  }

  BbsService.getBehaviorCategoryList(params).then(
    (response) => {
      let resultArr = {items:[{name: t('message.select'), value: ''}]}
      _.forEach(response.result, (val, key)=>{
        let tempObj = {name:val['categoryTitle'], value:val['idx']}
        resultArr.items.push(tempObj)

        if(key == 0)
          categoryIdx.value = val['idx']
      })
      categoryIdxSelect.value = resultArr
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickCategoryDialog = ()=>{
  storeRef.popupType.value = '2'  //리더십타입
  categoryDialogModel.value=true
}

const showDialog=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'behavior',
    parentIdx: viewIdx
  }
  LogService.getLogList(params).then(
    (response:any) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach((row)=> {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeNumModel.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>


<style lang="scss">
</style>
